import { useCallback } from 'react'
import {
  getPatientBaseHealthReport,
  type PatientBaseHealthReportResult,
} from '@services/api/reports/patients.api'
import type { ReportBucketType } from '@services/api/reports/finance.api'
import { useFinanceReportQuery } from '@hooks/reports/useFinanceReportQuery'

export type PatientBaseHealthReportData = PatientBaseHealthReportResult

export type UsePatientBaseHealthReportResult = {
  loading: boolean
  error: string | null
  data: PatientBaseHealthReportData | null
  bucketLabel: string
}

export function usePatientBaseHealthReport(
  toolbarSelection: Record<string, string>,
): UsePatientBaseHealthReportResult {
  const getBucketFromData = useCallback(
    (data: PatientBaseHealthReportResult): ReportBucketType =>
      data.patientPopulationTrend.bucket,
    [],
  )

  return useFinanceReportQuery({
    toolbarSelection,
    fetchReport: getPatientBaseHealthReport,
    getBucketFromData,
    errorMessage: 'Failed to load patient base health data',
  })
}
